import React, {Component} from "react";
import {Header} from "semantic-ui-react";
import {Header as MyHeader} from "../../components";
import ImgBanner from "../../assets/image/banner-home.jpg";

class Help extends Component {

    constructor(props) {
        super(props);

        this.state = {};
    }

    render() {
        return (
            <React.Fragment>
                <MyHeader ImgBanner={ImgBanner} verticalAlign={'center'}>
                    <Header as="h1" textAlign="center">
                        Help?
                    </Header>
                </MyHeader>
            </React.Fragment>
        );
    }
}

export default Help;

